import { render, staticRenderFns } from "./WorkflowView.vue?vue&type=template&id=dad38a6e"
import script from "./WorkflowView.vue?vue&type=script&lang=js"
export * from "./WorkflowView.vue?vue&type=script&lang=js"
import style0 from "./WorkflowView.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports